<!-- 引导页面 -->
<template>
<!--    <div class="giudepage"> -->
<!--        <div class="wx-title" v-if="isWx"></div>-->
<!--        <div class="giudepage_top">-->
<!--            <div class="giudepage_top_one"></div>-->
<!--            <div class="giudepage_top_two"></div>-->
<!--            <div class="giudepage_top_three"></div>-->
<!--            <div class="giudepage_top_four"></div>-->
<!--        </div>-->
<!--        <div class="giudepage_bottom" @click="handleIknow">我知道了</div>-->
<!--    </div>-->
</template>

<script>
export default {
    name: 'guidePage',
    data() {
        return {
            isWx:false
        }
    },
    mounted() {
        let ua = navigator.userAgent.toLowerCase();
	 this.isWx =  /micromessenger/.test(ua) 
    
    },
    methods: {
        handleIknow() {
            this.$emit('iknow')
        }
    }
}
</script>

<style lang="scss" scoped>
.giudepage {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.86);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .wx-title{
        width: 9rem;
        height: 3.8rem;
        background: url('~@/assets/img/phone/wx-title.png') no-repeat center;
        background-size: 100% 100%;
        margin-bottom: 0.3rem;
    }
    .giudepage_top {
        width: 8rem;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        .giudepage_top_one {
            width: 2.86rem;
            height: 2.88rem;
            background: url('~@/assets/img/guide/guide-icon-one.png') no-repeat center;
            background-size: 100% 100%;
            /*margin-right: 1.27rem;*/
            margin-bottom: 0.76rem;
        }
        .giudepage_top_two {
            width: 2.86rem;
            height: 2.88rem;
            background: url('~@/assets/img/guide/guide-icon-two.png') no-repeat center;
            background-size: 100% 100%;
            margin-bottom: 0.76rem;
          
        }
        .giudepage_top_three {
            width: 2.86rem;
            height: 2.88rem;
            background: url('~@/assets/img/guide/guide-icon-three.png') no-repeat center;
            background-size: 100% 100%;
            /*margin-right: 0.97rem;*/
           
        }
        .giudepage_top_four {
            width: 2.86rem;
            height: 2.88rem;
            background: url('~@/assets/img/guide/guide-icon-four-phone.png') no-repeat center;
            background-size: 100% 100%;
           
        }
    }    
    .giudepage_bottom {
        width: 2.48rem;
        height: 0.68rem;
        // border:2px solid #fff;
       
        background-image: url("~@/assets/img/phone/guide-btn.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        cursor: pointer;
        text-align: center;
        font-size: 0.28rem;
        font-weight: 800;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1.5rem;
        color: #fff;
    }
}
</style>
